type SitecoreContextMappingType = {
  sitecoreContextId: string;
  type: string;
  edgeEndpoint?: string;
  personalizeTenant: string;
  searchTenant: string;
};

type SitecoreContextType = {
  sitecoreContextId: string;
  name: string;
  description: string;
  organizationId: string;
  type: string;
  accountId: string;
  resources: SitecoreContextResourceType[];
  edgeEndpoint?: string;
  personalizeTenant?: string;
  searchTenant?: string;
};

type SitecoreContextResourceType = {
  id: string;
  name: string;
  type: string;
  tenantId: string;
  tenantName: string;
  tenantDisplayName: string;
  tenantProductCode: string;
  organizationId?: string; // Optional organization ID that might be present in the resource
  properties: SitecoreContextResourcesPropertyType[];
};

type SitecoreContextResourcesPropertyType = {
  id: string;
  value: string;
};

type CreateSitecoreContextType = {
  resources: SitecoreContextResourceType[];
};

type AddEditContextMappingSelectOption = {
  id: string;
  displayName: string;
  projectName?: string;
  environmentName?: string;
};

export type TGenerateContextIdPayload = {
  name: string;
  description: string;
};

export type TCreateScopedContextPayload = {
  sitecoreContextId: string;
  allowedResourceIds: string[];
  name: string;
};

type FilteredContext = {
  sitecoreContextId: string;
  masterSitecoreContextId: string;
  allowedResourceIds: string[];
};

type FilteredContextWithResources = {
  sitecoreContextId: string;
  name: string;
  masterSitecoreContextId: string;
  resources: SitecoreContextResourceType[];
};
export type TScopedContext = {
  masterSitecoreContextId: string;
  updatedAt: Date;
  createdAt: Date;
} & TCreateScopedContextPayload;

type ResourceType = {
  id: string;
  type: string;
  tenantId: string;
  tenantName: string;
};

type ResourceByProductType = {
  tenantId: string;
  tenantName: string;
  productCode: string;
  environment?: string;
  showHeader?: boolean;
};

type AvailableProduct = {
  productCode: string;
  tenantId: string;
  tenantName: string;
  environment?: 'Live' | 'Preview';
};

type TenantApplicationNode = {
  id: string;
  annotations: { key: string; value: string }[];
};

type RegenerateRedirectProps = {
  sitecoreContextId: string;
  resources?: SitecoreContextResourceType[];
  applicationsNodes: TenantApplicationNode[];
  onRedirectError: (additionalInfo?: string) => void;
};

type DeploymentInfo = {
  projectId: string;
  environmentId: string;
  isLoading: boolean;
  error: Error | null;
};

interface DeploymentResourceContext {
  resources: SitecoreContextResourceType[] | undefined;
  applicationsNodes: TenantApplicationNode[];
}

enum RegenerationErrorType {
  MISSING_PROJECT_ID = 'MISSING_PROJECT_ID',
  MISSING_ENVIRONMENT_ID = 'MISSING_ENVIRONMENT_ID',
  MISSING_ORGANIZATION_ID = 'MISSING_ORGANIZATION_ID',
  TENANT_NOT_FOUND = 'TENANT_NOT_FOUND',
  NO_ANNOTATIONS = 'NO_ANNOTATIONS',
  GENERAL_ERROR = 'GENERAL_ERROR',
  NO_TENANT_APPLICATIONS = 'NO_TENANT_APPLICATIONS',
  DATA_RETRIEVAL_ERROR = 'DATA_RETRIEVAL_ERROR',
}

type ErrorMessageMap = {
  [key in RegenerationErrorType]: string;
};

export {
  SitecoreContextMappingType,
  SitecoreContextType,
  SitecoreContextResourceType,
  SitecoreContextResourcesPropertyType,
  FilteredContext,
  FilteredContextWithResources,
  CreateSitecoreContextType,
  AddEditContextMappingSelectOption,
  ResourceType,
  ResourceByProductType,
  AvailableProduct,
  TenantApplicationNode,
  RegenerateRedirectProps,
  DeploymentInfo,
  DeploymentResourceContext,
  RegenerationErrorType,
  ErrorMessageMap,
};
